import jwtDecode from 'jwt-decode';
const hawaiiID = 'a9e7c78acf6d48698c5bf50d785c431f';

const initialState ={
  jwtToken: null,
  error: null,
  userEmail : 1,
  userId: 1,
  userState : null,
  courses: null,
  courseId : null,
};

function authReducer(state=initialState, action){
  switch (action.type){
    case "LOGIN_FULFILLED":{
      return Object.assign({}, state, {
        jwtToken: action.payload,
        userId: jwtDecode(action.payload).id,
        userEmail: jwtDecode(action.payload).email
      });
    }

    case "LOGIN_REJECTED":{
      return Object.assign({}, state, {
        error: action.payload
      });
    }

    case "REDIRECT_URL":{
      return Object.assign({}, state, {
        redirectUrl: action.payload
      });
    }

    case 'COURSES_FULFILLED':{
      let courseId = action.payload.recent_course?action.payload.recent_course:hawaiiID;
      return Object.assign({}, state, {
        courses: action.payload.courses,
        userState: action.payload.state,
        courseId: courseId,
      })
    }

    case 'SET_CONTENT':{
      return Object.assign({}, state, {
        courseId : action.payload
      })
    }

    case 'LOGOUT':{
      return Object.assign({},state,{
        initialState
      })
    }

    default:
      return state;
  }
}

export default authReducer;



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js